/**
 * @generated SignedSource<<c982c74901409bb34e160aa5c3350fa3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ActionItemPlatformPlatform = "INSTAGRAM" | "STREAMING" | "TIKTOK";
export type PlatformFormattedValue = "Instagram" | "Streaming" | "TikTok";
import { FragmentRefs } from "relay-runtime";
export type HomebaseGuidance_actionItem$data = {
  readonly checked: boolean | null;
  readonly description: string | null;
  readonly id: string;
  readonly platforms: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly platform: ActionItemPlatformPlatform;
        readonly platformFormatted: PlatformFormattedValue | null;
      } | null;
    } | null>;
  };
  readonly providerName: string | null;
  readonly providerUrl: string | null;
  readonly thumbnailUrl: string | null;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"useToggleCheckActionItem_actionItem">;
  readonly " $fragmentType": "HomebaseGuidance_actionItem";
};
export type HomebaseGuidance_actionItem$key = {
  readonly " $data"?: HomebaseGuidance_actionItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"HomebaseGuidance_actionItem">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomebaseGuidance_actionItem",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "providerName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "providerUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ActionItemPlatformNodeConnection",
      "kind": "LinkedField",
      "name": "platforms",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ActionItemPlatformNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ActionItemPlatformNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "platform",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "platformFormatted",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checked",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useToggleCheckActionItem_actionItem"
    }
  ],
  "type": "ActionItemNode",
  "abstractKey": null
};
})();

(node as any).hash = "9eb2fc526fa8a224e56e3225103dc624";

export default node;
